export default __webpack_public_path__ + "static/favicon-0c45102270dcc70e417092b68e387f21.png";